import { BoxProps, Flex, Text, Box } from "@chakra-ui/react";
import React from "react";
import { IconType } from "react-icons";
import ShadowSelectableButton from "ui/components/Button/ShadowSelectableButton";

interface IconShadowSelectableButtonProps {
  value: any;
  color: string;
  Icon: IconType;
  text: string;
  selected: boolean;
  onChange: (v: any) => any;
  onUnselect?: boolean;
  buttonProps?: BoxProps;
  iconSize?: number;
  fontSize?: number;
  h?: string;
  badge?: number;
}

const IconWrapper = ({
  bg,
  children,
  iconSize = 24,
}: {
  bg: string;
  children: React.ReactNode;
  iconSize?: number;
}) => (
  <Flex
    bgColor={bg}
    rounded="full"
    w={Math.ceil(iconSize / 2)}
    h={Math.ceil(iconSize / 2)}
    alignItems="center"
    justifyContent="center"
    position="relative"
  >
    {children}
  </Flex>
);

function IconShadowSelectableButton({
  value,
  color,
  Icon,
  text,
  badge,
  selected,
  onChange,
  onUnselect = true,
  buttonProps,
  iconSize = 22,
  fontSize = 13,
  h = "40px",
}: IconShadowSelectableButtonProps) {
  return (
    <ShadowSelectableButton
      w="100%"
      selected={selected}
      onClick={() => onChange(value)}
      onUnselect={() => (onUnselect ? onChange(undefined) : null)}
      h="130px"
      {...buttonProps}
    >
      <Flex flexDir="column" alignItems="center">
        <IconWrapper bg={color + "40"} iconSize={iconSize}>
          <Icon size={iconSize} color={color} />
          {badge && badge > 0 ? (
            <Box
              bg="red"
              color="white"
              rounded="full"
              minW={"16px"}
              px="2px"
              h={"16px"}
              position="absolute"
              top={-1}
              right={-1}
              fontSize={12}
              textAlign="center"
            >
              {badge}
            </Box>
          ) : null}
        </IconWrapper>

        <Text
          textAlign="center"
          h={h}
          display="flex"
          alignItems="center"
          fontSize={fontSize}
          mt={1}
        >
          {text}
        </Text>
      </Flex>
    </ShadowSelectableButton>
  );
}

export default IconShadowSelectableButton;
